// extracted by mini-css-extract-plugin
export default {"container":"SupportServiceComponent_container__iv8Sj","textCell":"SupportServiceComponent_textCell__Upmcm","rest":"SupportServiceComponent_rest__wqKhV"};